export default "__VITE_ASSET__a6a90da5__"